import { render, staticRenderFns } from "./safe-area.vue?vue&type=template&id=0441a3a2&"
import script from "./safe-area.vue?vue&type=script&lang=js&"
export * from "./safe-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports